const preloaded = new Set();

export function preloadImage(src) {
  if (!src || preloaded.has(src)) return; // Already loaded

  const img = new Image();
  img.src = src;

  preloaded.add(src);
}
